import { computed } from '@vue/composition-api'

import useCurrentInstance from './useCurrentInstance'

export default function useRouter () {
  const { vm } = useCurrentInstance()

  return computed(() => vm.proxy.$router)
}
